import { useFlags } from 'launchdarkly-react-client-sdk';

/** LaunchDarkly flag `servicefinance-prequals` (camelCase in SDK). */
export const useServiceFinancePrequalsEnabled = (): boolean => {
    const flags = useFlags();
    return flags.servicefinancePrequals === true;
};
